import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import PrivateRoutes from './Route'
import {
  SignIn,
  SignUp,
  Dashboard,
  Profile,
  Autenticate
} from './users/UsersRouter'
import { MenuRouter } from './config/MenuRouter'
import { RolesRouter } from './users/RolesRouter'
import { UsersRouter } from './config/UsersRouter'
import { PermissionsRouter } from './users/PermissionsRouter'
import { CacheRegisterRouter } from './cache/CacheRouter'
import { useAuth } from '../hooks/auth'
import { NotFoundPage } from '../pages/NotFound'
import { PermissionsAssociatedRouter } from './users/PermissionsAssociatedRouter'
import { IpAllowedRouter } from './users/IpAllowedRouter'
import { PartnersRouter } from './commercial/PartnersRoutes'
import { ProposalsRouter } from './commercial/ProposalsRoutes'
import { StatusProposalsRouter } from './commercial/StatusProposalsRoutes'
import { BanksRouter } from './commercial/BanksRoutes'
import { OriginsRouter } from './commercial/OriginsRoutes'
import { CreditLinesRouter } from './commercial/CreditLinesRoutes'
import { IndicationTypesRouter } from './commercial/IndicationTypesRoutes'
import { HiringsRouter } from './commercial/HiringsRoutes'
import { StatusHiringsRouter } from './commercial/StatusHiringsRoutes'
import { WarningsRouter } from './config/WarningRouter'

const Routes = () => {
  const { userLogged, backupHistory } = useAuth()
  return (
    <Switch>
      <Route path="/" exact component={SignIn}>
        {!backupHistory.length && userLogged() && <Redirect to="/dashboard" />}
      </Route>

      <Route path="/signup" component={SignUp} />
      <Route path="/autenticate/:data" component={Autenticate} />

      <PrivateRoutes path="/dashboard" component={Dashboard} />
      <PrivateRoutes path="/users/profile" component={Profile} />

      <Route path="/users/menus" component={MenuRouter} />

      <Route path="/users/roles" component={RolesRouter} />
      <Route path="/users/ipAllowed" component={IpAllowedRouter} />
      <Route path="/users/permissions" component={PermissionsRouter} />
      <Route
        path="/users/permissionsAssociated"
        component={PermissionsAssociatedRouter}
      />
      <Route path="/users" component={UsersRouter} />

      <Route path="/commercial/partners" component={PartnersRouter} />
      <Route path="/commercial/proposals" component={ProposalsRouter} />
      <Route
        path="/commercial/statusProposals"
        component={StatusProposalsRouter}
      />
      <Route path="/commercial/statusHirings" component={StatusHiringsRouter} />
      <Route path="/commercial/banks" component={BanksRouter} />
      <Route path="/commercial/hirings" component={HiringsRouter} />
      <Route path="/warnings" component={WarningsRouter} />
      <Route path="/commercial/creditLines" component={CreditLinesRouter} />
      <Route
        path="/commercial/indicationTypes"
        component={IndicationTypesRouter}
      />
      <Route path="/commercial/origins" component={OriginsRouter} />

      <Route path="/cache" component={CacheRegisterRouter} />

      <Route path="*" component={NotFoundPage} />
    </Switch>
  )
}
export default Routes
